import { h } from 'preact';

// eslint-disable-next-line max-len
const ProductDetails = ({ product, isQuickView = false, specialClass, isBenefits = true, isBundlePlp }) => {
  if (!product) return false;
  const { smellsLike, feelsLike, benefits } = product;
  return (
    <ul className={`${isQuickView ? 'mb-5' : 'border-t border-grey-4 mt-4'} `}>
      {!isQuickView && !isBenefits && feelsLike && (
        <li
          className={`border-b border-grey-4 py-[18px] ${
            isQuickView ? '' : specialClass
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.feelsTitle}
          </span>
          <span className="block text-body-2">{feelsLike}</span>
        </li>
      )}
      {!isQuickView && !isBenefits && smellsLike && (
        <li
          className={`border-b border-grey-4 py-[18px] ${
            isQuickView ? '' : specialClass
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.smellsTitle}
          </span>
          <span className="block text-body-2">{smellsLike}</span>
        </li>
      )}
      {isBenefits && benefits && (
        <li
          className={`border-b border-grey-4 ${
            isQuickView
              ? `py-[18px] last-of-type:mb-0`
              : `py-[18px] ${specialClass}`
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.benefitsTitle}
          </span>
          <span className="block text-body-2">{benefits}</span>
        </li>
      )}
      {isBundlePlp && isQuickView && smellsLike && (
        <li
          className={`border-b border-grey-4 ${
            isQuickView
              ? `py-[18px] last-of-type:mb-0`
              : `py-[18px] ${specialClass}`
          }`}
        >
          <span className="block text-body-2 font-medium">
            {window.TMW.Strings.product.smellsTitle}
          </span>
          <span className="block text-body-2">{smellsLike}</span>
        </li>
      )}
    </ul>
  );
};

export default ProductDetails;
